import script from "./windowPP.vue?vue&type=script&setup=true&lang=js"
export * from "./windowPP.vue?vue&type=script&setup=true&lang=js"

import "./windowPP.vue?vue&type=style&index=0&id=4ef7311c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ef7311c"]])

export default __exports__